<template>
  <div id="navBar" :class="{ inLevel2: navStatus.level === 2 }">
    <div class="nav-box">
      <div class="bg"></div>
      <ul class="nav">
        <li
          v-for="(item, key) in nav"
          :key="key"
          :class="{ active: isRouterWatched(item.name) }"
          :name="item.name"
          @click="linkTo(item.name)"
        >
          <div class="active-bg"></div>
          <div class="label-box">
            <span class="label-shadow">{{ item.label }}</span>
            <span class="label-text">{{ item.label }}</span>
            <UiTipDot
              v-show="item.name === 'Quiz' && showLingqu.quizHots.quizTop"
              placement="label"
            ></UiTipDot>
            <UiTipDot
              v-show="item.name === 'Store' && showLingqu.taskHots.shopTop"
              placement="label"
            ></UiTipDot>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAppStore, useStageStore } from '@/store'
import UiTipDot from '@/components/ui-tip-dot.vue'
import * as api from '@/service/index'


const route = useRoute()
const router = useRouter()

const appStore = useAppStore()
const stageStore = useStageStore()

const hasStageModulesInit = ref(false)

const navStatus = computed(() => appStore.navStatus)
const token = computed(() => appStore.token)
const showLingqu = computed(() => appStore.showLingqu)
const modulesEnabled = computed(() => stageStore.modulesEnabled)
const nav = computed(() => {
  let temp_nav = [{ label: '赛程&奖金', name: 'Schedule' }];
  let other_nav = [
    { label: '活动&商城', name: 'Store' },
    { label: '直播', name: 'Live' },
    { label: '战队人气值', name: 'Ranking' },
    { label: '竞猜', name: 'Quiz' },
  ];
  if(modulesEnabled.value) {
    temp_nav.push(...other_nav);
  }

  return temp_nav;
})

async function initStageModules() {
  if (hasStageModulesInit.value || !modulesEnabled.value || !token.value) {
    return
  }

  hasStageModulesInit.value = true
  await appStore.reqUserInfo(true)
  let avatar = route.query?.avatar
  let taptapavatar = route.query?.taptapavatar
  await getupdateUseavatar(avatar, taptapavatar)
  appStore.reqRedDotState()
  appStore.reqMatchSimpleSeasons()
}
function isRouterWatched(name) {
  let isWatched = route.matched.some(record => {
    if(name === 'Ranking') {
      return record.name === name || record.name === 'Detail'
    } else {
      return record.name === name
    }
  });
  return isWatched;
}
function linkTo(name) {
  if (!isRouterWatched(name) && modulesEnabled.value) {
    router.push({
      name: name
    })
    // 获取竞猜币余额
    if (name !== 'ranking' && name !== 'Schedule'  ) {
      // LIVE reqUserInfo
      // this.reqUserInfo(false)
      appStore.reqRedDotState()
    }
  }
}

async function getupdateUseavatar(avatar, taptapavatar) {
  // 上传头像
  const storedAvatar = localStorage.getItem('DCavatar')
  const storedTaptapAvatar = localStorage.getItem('DCtaptapavatar')

  if (
    (!storedAvatar && !storedTaptapAvatar) ||
    avatar !== storedAvatar ||
    taptapavatar !== storedTaptapAvatar
  ) {
    const data = {
      avatar: avatar || 'Portrait1',
      taptapavatar: taptapavatar || ''
    }

    localStorage.setItem('DCavatar', data.avatar)
    localStorage.setItem('DCtaptapavatar', data.taptapavatar)

    if(!token.value) return;
    try {
      await api.updateUserAvatar(token.value, data)
    } catch (err) {
      console.log(err)
    }
  }
}

watch(token, () => {
  initStageModules()
}, { immediate: true })
watch(modulesEnabled, () => {
  initStageModules()
}, { immediate: true })
</script>

<style lang="scss" scoped>
#navBar {
	position: relative;
	width: 100%;
	height: get_vh(64);
	margin-bottom: get_vh(7);
  flex-direction: column;
	z-index: 10;
	display: flex;
	justify-content: space-between;
	overflow: hidden;

	.nav-box {
		position: relative;
		width: 100%;
    height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.bg {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: url(https://website.xdcdn.net/poster/58881/26match/tab/PD2Gplo9.jpg) center/100% 100% no-repeat;
			z-index: -1;
		}

		.nav {
			display: flex;
			justify-content: flex-end;
			align-items: center;
			color: #fff;
      @include r(height, 62);
			li {
				position: relative;
				@include r(width, 226);
        height: 100%;
				@include r(font-size, 26);
				cursor: pointer;
				-webkit-tap-highlight-color: transparent;
				display: flex;
				justify-content: center;
				align-items: center;
				font-weight: bold;
        // &::before {
        //  transition: opacity ease-in-out 200ms;
        //  content: '';
        //  position: absolute;
        //  inset: 0;
        //  transform: skewX(-30deg);
        //  background: #DDD;
        //  box-sizing: border-box;
        //  z-index: 0;
        // }
        // &:nth-of-type(2n) {
        //  &::before {
        //    background: #E9E9E9;
        //  }
        // }
				.active-bg {
					position: absolute;
					@include r(width, 256);
					height: 100%;
					background: url(https://website.xdcdn.net/poster/58881/26match/tab/PD28Onea.png) center/contain no-repeat;
					opacity: 0;
				}
        .label-box {
          .label-shadow {
            color: transparent;
          }
          .label-text {
            color: #FFFFFF;
          }
        }

				&.active {
          // &::before {
          //  opacity: 0;
          // }
					.active-bg {
						opacity: 1;
					}
					.label-box {
						.label-shadow {
							color: #443A28;
						}
						.label-text {
							color: #FFFFFF;
						}
					}
				}

				&:last-of-type {
					margin-right: 0;
				}
			}
		}
	}

	&.inLevel2 {
		background-color: transparent;
	}
}
</style>
